import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#077A97",
    height: 60,
    width: "100%",
    position: "absolute",
    top: 0,
    zIndex: 999,
  },

  content: {
    width: "auto",
    height: 60,
    paddingLeft: 15,
    paddingRight: 15,
    flexDirection: "row",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "space-evenly",
  },

  label: {
    marginTop: -2,
    color: "#FFF",
    fontSize: 14,
  },

  labelMobile: {
    marginBottom: 10,
    color: "#077A97",
    fontSize: 18,
  },

  imageLogo: {
    width: 96,
    height: 55.45,
  },

  imagePerfil: {
    width: 40,
    height: 40,
    tintColor: "#FFFFFF",
  },

  labelActive: {
    marginTop: -2,
    color: "#222",
    fontSize: 14,
    borderStyle: "1px solid #196059",
    borderBottomWidth: "1px",
    borderBottomColor: "#196059",
  },
  tab: {
    textTransform: "uppercase",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 10,
    paddingRight: 10,
  },

  menu: {
    borderWidth: 0.5,
    borderColor: "#077A97",
    borderRadius: 8,
    padding: 12,
    marginTop: 140,
    alignSelf: "center",
    width: 200,
    backgroundColor: "#FFF",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
});

export default styles;
